declare namespace $ {

	type $shm_hitalama_map_widget_float_notebook2_adds__Map_page_shm_hitalama_map_widget_float_notebook2_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['Map_page'] >
	>
	type $shm_hitalama_map_widget_float_notebook2_adds__add_types_shm_hitalama_map_widget_float_notebook2_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_notebook2['add_types'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_notebook2_adds['add_types'] >
	>
	export class $shm_hitalama_map_widget_float_notebook2 extends $shm_hitalama_map_widget_float_layout_vert {
		add_types( ): readonly(any)[]
		Adds( ): $shm_hitalama_map_widget_float_notebook2_adds
	}
	
}

//# sourceMappingURL=notebook2.view.tree.d.ts.map